// Page_Billings.jsx
import React, { useState, useEffect } from "react";
import { Button, Dropdown, Loader } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListBilling,
  BillingForm,
} from "../../../components/Admin/EducaBillingComp";
import { useAuth } from "../../../hooks";
import { BillingsAPI } from "../../../api/billingsAPI"; // Ajusta la ruta
import "./Page_Billings.scss";

// Opciones de roles para el Dropdown
const roleOptions = [
  { key: "all", value: "all", text: "Todos los roles" },
  { key: "client", value: "client", text: "Cliente" },
  { key: "partner", value: "partner", text: "Partner" },
  { key: "teacher", value: "teacher", text: "Profesor" },
  { key: "institution", value: "institution", text: "Institución" },
];
const billingController = new BillingsAPI();

export function Page_Billings() {
  const [role, setRole] = useState("all");
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [billings, setBillings] = useState(null);

  const { accessToken } = useAuth();

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  useEffect(() => {
    (async () => {
      try {
        // Llamamos al servicio con el role seleccionado
        const response = await billingController.getBillingsByRole(
          accessToken,
          role,
        );
        setBillings(response.data); // data es un array de facturas
        console.log("billings", response.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [role, reload, accessToken]);

  const onChangeRole = (e, { value }) => {
    setRole(value);
  };

  return (
    <div className="page-billings">
      {/* Encabezado con selector de roles y botón de creación */}
      <div className="page-billings__header">
        <Dropdown
          selection
          options={roleOptions}
          value={role}
          onChange={onChangeRole}
          className="filter-dropdown"
        />
        <Button primary onClick={onOpenCloseModal}>
          Nuevo Pedido
        </Button>
      </div>

      {/* Cuerpo principal: listamos las facturas o un Loader si aún cargan */}
      {!billings ? (
        <Loader active inline="centered" />
      ) : (
        <ListBilling billings={billings} onReload={onReload} />
      )}

      {/* Modal para crear factura */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nueva factura"
        size="large"
      >
        <BillingForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </div>
  );
}
